import React from 'react';
import 'react-widgets/dist/css/react-widgets.css';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import GridItem from 'components/core/Grid/GridItem';
import Button from 'components/core/CustomButtons/Button';
import SubmitButton from 'components/core/CustomButtons/SubmitButton';
import Card from 'components/core/Card/Card';
import CardHeader from 'components/core/Card/CardHeader';
import CardBody from 'components/core/Card/CardBody';
import { Multiselect } from 'react-widgets';

class RejectForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reasons: [],
    };
  }

  handleRejectReasonChange = value => {
    const array = [];
    // eslint-disable-next-line no-unused-vars
    value.map(data => array.push(data.id));
    this.setState({ reasons: array });
  };

  handleRejection = () => {
    this.props.onSubmit(this.state.reasons);
    this.props.onCancel();
  };

  render() {
    const { classes, selectReason = [], onCancel } = this.props;
    const TagItem = ({ item }) => <span className="premium-multiselect-tag">{item.name}</span>;

    return (
      <Card className={classes.modalCard}>
        <CardHeader className={classes.modalHeader}>
          <p className={classes.title}>رفض الطلب</p>
          <p className={classes.modalSubtitle}>اختر سبباً أو أكثر لرفض هذا الطلب</p>
        </CardHeader>
        <CardBody className={classes.modalContainer}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl className={classes.row}>
              <label className={classes.mLabel} htmlFor="reject-reasons">
                سبب الرفض
              </label>
              <div className={`${classes.rejectSelectWrap} premium-multiselect`}>
                <Multiselect
                  id="reject-reasons"
                  data={selectReason}
                  tagComponent={TagItem}
                  textField="name"
                  valueField="id"
                  onChange={value => this.handleRejectReasonChange(value)}
                  caseSensitive={false}
                  filter="contains"
                  placeholder="اختر سبب الرفض..."
                  messages={{
                    emptyList: 'لا توجد أسباب متاحة',
                    emptyFilter: 'لا توجد نتائج مطابقة',
                  }}
                />
              </div>
            </FormControl>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <div className={classes.modalFooter}>
              <Button color="danger" outline onClick={onCancel}>
                إلغاء
              </Button>
              <SubmitButton
                color="primary"
                onClick={this.handleRejection}
                disabled={!this.state.reasons[0]}
              >
                إرسال
              </SubmitButton>
            </div>
          </GridItem>
        </CardBody>
      </Card>
    );
  }
}

RejectForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  selectReason: PropTypes.array.isRequired,
};

export default RejectForm;
